import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toAbsoluteUrl } from "../../_helpers";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL, IVPCURRENCY } from "../../../env_config";
import { useHistory } from "react-router-dom";
import { SwalSuccess  } from "./";
import SweetAlert from "react-bootstrap-sweetalert";
import { Backdrop,CircularProgress, makeStyles,} from "@material-ui/core";
import {OverlayTrigger,Tooltip} from "react-bootstrap";
import { FaInfoCircle,FaEdit} from "react-icons/fa";
import getSymbolFromCurrency from "currency-symbol-map";
import DiamondTypeTag from "./DiamondTypeTag";
import CertificateLink from "../CertificateLink";

const perfectScrollbarOptions = {
    wheelSpeed: 1,
    wheelPropagation: false,
};


const shadeMappings = {
    "none": { label: "No.SH", tooltip: "Shade: NONE" },
    "brown": { label: "BR", tooltip: "Shade: Brown" },
    "light brown": { label: "L.BR", tooltip: "Shade: Light Brown" },
    "green": { label: "GR", tooltip: "Shade: Green" },
    "light green": { label: "L.GR", tooltip: "Shade: Light Green" },
    "grey": { label: "GREY", tooltip: "Shade: Grey" },
    "black": { label: "BLK", tooltip: "Shade: Black" },
    "pink": { label: "PINK", tooltip: "Shade: Pink" },
    "blue": { label: "BLUE", tooltip: "Shade: Blue" },
    "mix tinge": { label: "MIX", tooltip: "Shade: Mix Tinge" },
};

const renderShadeLabel = (shade) => {
    const mapping = shadeMappings[shade ? shade.toLowerCase() : ""];
    if (!mapping) return null;

    return (
        <span>
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip">{mapping.tooltip}</Tooltip>}
            >
                <span className={`label label-light-primary label-light-shade_${shade.toLowerCase().replace(' ', '_')} label-pill label-inline label-sm mr-1 font-weight-bold px-2`}>{mapping.label}</span>
            </OverlayTrigger>
        </span>
    );
};
const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }));
export const ConfirmGoods = (props) => {
    const classes = useStyles();
    const [couponCode,setCouponCode] = useState("")
    const [displayCoupon,setDisplayCoupon] = useState(false)
    const [couponsuccessmsg,setCouponSuccessMsg] = useState("")
    const [couponerrormsg,setCouponErrorMsg] = useState("")
    const [showConfirm, setShowConfirm] = useState(false);
    const [swalSuccessOpen,setSwalSuccessOpen] = useState(false)
    const [swalErrorOpen,setSwalErrorOpen] = useState(false)
    const [alertMessage,setAlertMessage] = useState()
    const [inputValue, setInputValue] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = React.useState(false);
    const [isSubmitting ,SetIsSubmitting] = useState(false)
    const [openLoader, setOpenLoader] = React.useState(false);
    const [ip,setIp] = React.useState()
    const [data , setData] =useState([])
    const [availabilitydata,setAvailabilityData] = useState([])
    const [totalourprice,setTotalOurPrice] = useState(0)
    const [totalourcarat,setTotalOurCarat] = useState(0)
    const [totalourpricecustomer,setTotalOurPriceCustomer] = useState(0)
    const [totalourratecustomer,setTotalOurRateCustomer] = useState(0)
    const [totalvalid,setTotalvalid] = useState(0)
    const [customerCurrencyRate, setCustomerCurrencyRate] = useState(1); 
    const [customerCurrencySymbol, setCustomerCurrencySymbol] = useState(null);
    const [customerCurrencySymbolName, setCustomerCurrencySymbolName] = useState(null);
    const [displayTotalUSD, setDisplayTotalUSD] = useState(false);

    const enableLoading = () => {
        setLoading(true);
        setOpenLoader(true);
        SetIsSubmitting(true)
    };
    const disableLoading = () => {
        setLoading(false);
        setOpenLoader(false);
        SetIsSubmitting(false)
    };

    const history = useHistory()
    useEffect(() => {
        let BASEURL = "https://api.staging.global.diamondsupload.com"
        if (process.env.REACT_APP_ENV === "production") {
            BASEURL = "https://api.global.diamondsoncall.com"
        }
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${BASEURL}/coupon/checkCouponRegionAvailable`,
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
            },
            data: {
                "region": "Global"
            }
        };
        axios.request(config)
            .then((response) => {
                if (response?.data?.couponavailable) {
                    setDisplayCoupon(true)
                }
            })
            .catch((error) => {
                if(error?.response?.data?.message === "UnAuthorized!"){
                    var cookies = document.cookie.split(";");
                  for (var i = 0; i < cookies.length; i++) {
                    if(cookies[i] && !cookies[i].includes("view")){
                      var equals = cookies[i].indexOf("=");
                      var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    }
                  }
                  
                  window.location.replace(`${BASE_URL}/logout`);
                }
            });
    },[])
    useEffect(() => {
        setData(props.diamondselected || [])
        SetComment(null)
        setShowConfirm(props.show)
        axios({
            method: 'GET',
            url:"https://api.ipify.org",
            })
            .then(function (res) {
                if(res && res.data){
                    setIp(res.data)                    
                }
            })
            .catch((res) => {
            });
    },[props.show])
    useEffect(() => {
        if (props.diamondselected && props.diamondselected.length && props.show) {
            enableLoading()
            let availibilitycheck = []
            for (let i = 0; i < props.diamondselected.length; i++) {
                if (props.diamondselected[i]?.status_api_available?.toString() === "1") {
                    availibilitycheck.push({
                        sup_id: props.diamondselected[i]?.sup_id,
                        stoneno: props.diamondselected[i]?.loatNo,
                        diamond_type: props.diamondselected[i]?.diamondType,
                        doc_stock_id: props.diamondselected[i]?.stockID
                    })
                }
            }
            if (availibilitycheck.length) {
                let BASEURL = "https://api.staging.global.diamondsupload.com"
                if (process.env.REACT_APP_ENV === "production") {
                    BASEURL = "https://api.global.diamondsoncall.com"
                }
                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: `${BASEURL}/supplier/getAvailibilityStatus`,
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
                    },
                    data: {
                        supplierdata: availibilitycheck
                    }
                };

                function debounce(func, delay) {
                    let timeoutId;
                    return function (...args) {
                        clearTimeout(timeoutId);
                        timeoutId = setTimeout(() => {
                            func.apply(this, args);
                        }, delay);
                    };
                }
                
                // Debounced Axios request
                const debouncedRequest = debounce((config) => {
                    axios.request(config)
                        .then((response) => {
                            disableLoading();
                            if (response?.data?.data) {
                                setAvailabilityData(response?.data?.data);
                            }
                        })
                        .catch((error) => {
                            disableLoading();
                            console.log(error);
                        });
                }, 300); // 300ms delay
                debouncedRequest(config);
            }
            else{
                disableLoading()
            }
        }
    }, [props.diamondselected,props.show])
    useEffect(() => {
        if (data.length) {
            if(data?.[0]?.customerCurrencyRate && data?.[0]?.ourPriceCustomerSymbol){
                setCustomerCurrencyRate(data?.[0]?.customerCurrencyRate)
                setCustomerCurrencySymbol(data?.[0]?.ourPriceCustomerSymbol)
                setCustomerCurrencySymbolName(data?.[0]?.ourPriceCustomerSymbolName)
            }
            if(data?.[0]?.displayTotalUsd){
                setDisplayTotalUSD(data?.[0]?.displayTotalUsd)
            }
            let totalprice = 0
            let totalcarat = 0
            let totalvalid = 0
            let totalpricecustomer = 0
            for (let i = 0; i < data.length; i++) {
                let available = true
                let checkavailable = availabilitydata.find(avvalue => avvalue?.stoneno?.toString() === data[i]?.loatNo?.toString())
                if (checkavailable?.status === "UnAvailable") {
                    available = false
                }
                if(available){
                    totalvalid += 1
                    totalprice += data[i].ourPrice
                    totalcarat += data[i].carat
                    if(data[i].ourPriceCustomer){
                        totalpricecustomer += data[i].ourPriceCustomer
                    }
                }
            }
            setTotalOurPrice(totalprice)
            setTotalOurPriceCustomer(totalpricecustomer)
            setTotalOurRateCustomer(totalpricecustomer/totalcarat || 0)
            setTotalOurCarat(totalprice/totalcarat || 0)
            setTotalvalid(totalvalid)
        }
    }, [data, availabilitydata])

    const closeModel = () => {
        props.onHide()
        setShowConfirm(false)
        setCouponCode("")
        setCouponSuccessMsg("")
        setCouponErrorMsg("")
    }
    
    const swalErrorOpenfn = (props) => {
        closeModel()
        setSwalErrorOpen(true)
    }
    
    const swalSuccessOpenfn = (props) => {
        closeModel()
        setSwalSuccessOpen(true)
    }
   
    const ConfirmDiamonds = (diamonds) => {
        // let dianondinfo = diamonds.map(value => {
        //     return {
        //         diamond_id:value.stockID,
        //         diamond_type:value.diamondType === "L"  ? value.diamondType:"N",
        //         Certi_NO:value.certificate,
        //         client_ref:value.client_ref
        //     }
        // })
        let dianondinfo = []
        for (let i = 0; i < diamonds.length; i++) {
            let available = true
            let checkavailable = availabilitydata.find(avvalue => avvalue?.stoneno?.toString() === diamonds[i]?.loatNo?.toString())
            if (checkavailable?.status === "UnAvailable") {
                available = false
            }
            if(available){
                dianondinfo.push({
                    diamond_id:diamonds[i].stockID,
                    diamond_type:diamonds[i].diamondType === "L"  ? diamonds[i].diamondType:"N",
                    certificate:diamonds[i].certificate,
                    client_ref:diamonds[i].client_ref
                })
            }
        }
        const finalData = {
            "user_id":props.userinfo.id,
            "operation":"buy",
            "diamond_info":dianondinfo,
            "customer_comment":comment,
            "ip":ip,
            "couponcode":couponCode
        }
        if(props?.buyFrom && props?.consumerId){
            finalData["buy_from"] = props.buyFrom;
            finalData["ConsumerId"] = props.consumerId;
        }
        enableLoading()
        let BASEURL = "https://api.staging.global.diamondsupload.com"
        if(process.env.REACT_APP_ENV === "production"){
            BASEURL = "https://api.global.diamondsoncall.com"
        }
        axios({
            method: "POST",
            url: `${BASEURL}/INTL/ConformDiamond`,
            headers: {
                "Content-Type": "application/json",
                 "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            },
            data: finalData,
        }).then(res => {
            disableLoading()
            if (res.data.success === false){
                swalErrorOpenfn()
                setAlertMessage(res.data.message)
            }
            if(res && res.data && res.data.success){
                setAlertMessage(res.data.data[0].status)
                for(let i = 0 ; i < res.data.data.length;i++){
                    if(res.data.data[i].issuccess === true){
                        swalSuccessOpenfn()
                        reDirectToConfirm()
                    } else if (res.data.data[i].issuccess === false || res.data.data[i].ssuccess===false){
                        swalErrorOpenfn()
                    }
                }
                SetComment(null)
            }
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
    }
    
    const handleInputChange = (event,buyDataIdData,index) => {
        const value = event.target.value;
        setInputValue(value);
        if (value.length > 29) {
          setErrorMessage('String length should not exceed 30 characters.');
        } else {
          setErrorMessage('');
        }
        let buyDataId = [...buyDataIdData]
        buyDataId[index] = {...buyDataId[index],client_ref:event.target.value}
        setData(buyDataId)
    };

    const AddReference = (buyDataIdData,index) => {
        let buyDataId = [...buyDataIdData]
        buyDataId[index] = {...buyDataId[index],addref:true}
        setData(buyDataId)
        
    }

    const reDirectToConfirm = () => {
        history.push({
            pathname: `/confirmgoods`
        })
    }
    const [comment,SetComment] = useState()
    function numberWithCommas(x) {
        return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    const handleApplyCoupon = () => {
        enableLoading()
        let BASEURL = "https://api.staging.global.diamondsupload.com"
        if (process.env.REACT_APP_ENV === "production") {
            BASEURL = "https://api.global.diamondsoncall.com"
        }
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${BASEURL}/coupon/applyCoupon`,
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
            },
            data: {
                "coupon": couponCode,
                "certificates": data.map(value => value.certificate)
            }
        };
        axios.request(config)
            .then((response) => {
                disableLoading();
                if (response?.data?.success) {
                    setCouponErrorMsg("")
                    setCouponSuccessMsg(response?.data?.message);
                }
                else {
                    setCouponSuccessMsg("")
                    setCouponErrorMsg(response?.data?.message);
                }
            })
            .catch((error) => {
                disableLoading();
                if(error?.response?.data?.message === "UnAuthorized!"){
                    var cookies = document.cookie.split(";");
                  for (var i = 0; i < cookies.length; i++) {
                    if(cookies[i] && !cookies[i].includes("view")){
                      var equals = cookies[i].indexOf("=");
                      var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    }
                  }
                  
                  window.location.replace(`${BASE_URL}/logout`);
                }
            });
    }
    return (
        <div>
            <Backdrop className={classes.backdrop} open={openLoader} >
                <div className="px-5 py-3 bg-white rounded shadow-sm d-flex justify-content-center align-items-center"><CircularProgress size="30px" color="secondary" /> <span className="pl-2 font-weight-bold text-dark">Processing..</span></div>
            </Backdrop>
            <Modal
                show={showConfirm}
                onHide={props.onHide}
                backdrop="static"
                keyboard={false}
                size="xl"
            >
                <Modal.Header>
                    <Modal.Title>{props.language.CONFIRM_GOODS_POPUP_CONFIRM_DIAMOND}</Modal.Title>
                    <div className="d-flex">
                        {customerCurrencySymbolName ?
                            <div className=" font-weight-bold font-size-lg d-flex mr-4">
                            {customerCurrencySymbolName} Rate: <div className="ml-2">{customerCurrencySymbol}{customerCurrencyRate}</div >
                            </div>
                        : null}
                        <button type="button" className="close" onClick={() => closeModel(props)}><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 d-flex justify-content-between mb-3">
                            <span>{props.language.CONFIRM_GOODS_POPUP_CONFIRM_DIAMOND} : {props.diamondselected.length}</span>
                            <div>
                                {((props.diamondselected.length) - totalvalid ) == 0 ||  totalvalid == 0? "":
                                 <div className="d-flex font-weight-bold">
                                    <div className="text-success mr-2">{totalvalid} Diamond Available</div> 
                                    <div className="text-danger">{((props.diamondselected.length) - totalvalid )} Diamond Not Available</div>
                                </div>}
                            </div>
                        </div>
                        <div className="col-12">
                            <div
                                options={perfectScrollbarOptions}
                                className="custom-scrollbar border-bottom"
                                style={{ maxHeight: "322px", position: "relative" }}
                            >
                                <table className="table border-bottom">
                                    <thead>
                                        <tr className="bg-gray-100 sticky-top">
                                            <th className="text-center py-3">{props.language.CONFIRM_GOODS_POPUP_DIAMOND_DETAILS}</th>
                                            <th className="text-center py-3">{props.language.CONFIRM_GOODS_POPUP_DIAMOND_LOCATION} <br /> {props.language.CONFIRM_GOODS_POPUP_DIAMOND_SHIPPING_DAYS}</th>
                                            <th className="py-3">Advanced Tag</th>
                                            <th align="center" className="text-right py-3">
                                                {props.language.CONFIRM_GOODS_POPUP_OURPRICEUSD} <br />
                                                USD/CT
                                            </th>
                                            {customerCurrencySymbolName ?
                                                <th align="center" className="text-right py-3">
                                                    Our Price ({customerCurrencySymbolName}) <br />
                                                    {customerCurrencySymbol}/CT
                                                </th> 
                                            : null}
                                            <th className="text-center  py-3 align-middle">
                                                Client <br />
                                                Reference
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {data.map((value,index) => {
                                        let available = true
                                        let checkavailable = availabilitydata.find(avvalue => avvalue?.stoneno?.toString() === value?.loatNo?.toString())
                                        if(checkavailable?.status === "UnAvailable"){
                                            available = false
                                        }
                                        return (
                                            <tr className={`position-relative ${(value.diamondType === "N" || value.diamondType === "W") && (value.treatment && value.treatment.toLowerCase() !== "none") ? 'bg-danger-o-20' : ''} ${!available?"not-holdable-tr":""}`} key={index}>
                                                <td>
                                                    {/* {value.country !== "INDIA"?
                                                        <span className="CanNotHold"> Unfortunately, Diamond location outside India cant be ordered</span>
                                                    :""} */}
                                                    {/* {value.can_hold === 1 ? "":  <span style={{fontSize:"8px",color:"red"}}> DIAMOND NOT AVAILABLE FOR HOLD</span> } */}
                                                    { !available ?  <span className="NotAvailable"></span> : ""}
                                                    <div className={`d-flex ${!available ? "CanNotHoldDiv" : "" }`}>
                                                        <div className="text-center p-0">
                                                            {value.image ? (
                                                                <img className="mr-2" alt={value.shape} src={value.image} width="50px" />
                                                            ) : (
                                                                <img className="mr-2" alt={value.shape} src={toAbsoluteUrl(`/media/shape/${value.shape.toLowerCase()}-no.png`)} onError={e => {
                                                                    e.currentTarget.src = toAbsoluteUrl(
                                                                        `/media/shape/noimage.jpg`
                                                                    )
                                                                }} width="50px" style={{ backgroundColor:"#f4f4f4", }} />
                                                            )}
                                                        </div>
                                                        <div className="pl-2 p-0">
                                                            <div className="mb-1">
                                                                <span>
                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        overlay={
                                                                            <Tooltip id="tooltip">
                                                                                {value.availability === "Memo" ||
                                                                                value.availability === "Hold"
                                                                                    ? `Business Process`
                                                                                    : value.availability === "Guaranteed"
                                                                                    ? `Guaranteed`
                                                                                    : value.availability === "Not Available"
                                                                                    ? `Not Available`
                                                                                    : value.availability === "Subject to Prior sale"
                                                                                    ? `Subject to Prior sale`
                                                                                    : `Unknown`}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <img
                                                                            className="img-fluid availIco mr-2"
                                                                            alt={value.availability}
                                                                            src={toAbsoluteUrl(
                                                                                `/media/svg/${
                                                                                    value.availability === "Memo" ||
                                                                                    value.availability === "Hold"
                                                                                        ? `availability_primary.svg`
                                                                                        : value.availability === "Guaranteed"
                                                                                        ? `availability_success.svg`
                                                                                        : value.availability === "Not Available"
                                                                                        ? `availability_danger.svg`
                                                                                        : value.availability ===
                                                                                        "Subject to Prior sale"
                                                                                        ? `availability_warning.svg`
                                                                                        : `availability_blank_gray.svg`
                                                                                }`
                                                                            )}
                                                                        />
                                                                    </OverlayTrigger>
                                                                </span>
                                                                <DiamondTypeTag diamondTypeTagColor={value.diamondTypeTagColor} diamondTypeTag={value.diamondTypeTag}/>
                                                                <CertificateLink Certificate_link={value.certificate_link} lab={value.lab} certificate={value.certificate} className={`mx-2 small`}  displaycertificate={value?.showcertificate}/>
                                                                <span className="small mr-3">
                                                                    {value.diamondType === "N" || value.diamondType === "W" ? "N" : "L"}-{value.stockID}
                                                                </span>
                                                                
                                                            </div>
    
                                                            <span className="text-dark font-weight-bold d-block">
                                                                {value.shape}{" "}
                                                                {value.carat.toFixed(2)}{" "}
                                                                {value.color}{" "}
                                                                {value.clarity}{" "}
                                                                {value.cut}{" "}
                                                                {value.polish}{" "}
                                                                {value.symmetry}{" "}
                                                                {value.fluorescence}{" "}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className={`text-center  ${!available ? "CanNotHoldDiv" : "" }`}>
                                                    {value.location} <br />
                                                    {value.shippingDays} days
                                                </td> 
                                                <td className={``}>
                                                    <div className="advTag" style={{ maxWidth: "150px" }}>
                                                        {/* shade */}
                                                        {renderShadeLabel(value.shade)}
                                                        
                                                        { value.milky && value.milky.toLowerCase() === "no milky" ?
                                                            <span>
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip">
                                                                            NO MILKY
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="label label-light-no_milky label-pill label-inline label-sm  mr-1 font-weight-bold px-2">NO.ML</span>
                                                                </OverlayTrigger>
                                                            </span>
                                                        :
                                                            null
                                                        }
    
                                                        { value.milky && value.milky.toLowerCase() === "luster low" ?
                                                            <span>
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip">
                                                                            Luster Low
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="label label-light-luster_low label-pill label-inline label-sm  mr-1 font-weight-bold px-2">LL</span>
                                                                </OverlayTrigger>
                                                            </span>
                                                        :
                                                            null
                                                        }
    
                                                        { value.milky && value.milky.toLowerCase() === "light milky" ?
                                                            <span>
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip">
                                                                            LIGHT MILKY
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="label label-light-light_milky label-pill label-inline label-sm  mr-1 font-weight-bold px-2">L.ML</span>
                                                                </OverlayTrigger>
                                                            </span>
                                                        :
                                                            null
                                                        }
    
                                                        { value.milky && value.milky.toLowerCase() === "milky" ?
                                                            <span>
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip">
                                                                            MILKY
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="label label-light-milky label-pill label-inline label-sm  mr-1 font-weight-bold px-2">H.ML</span>
                                                                </OverlayTrigger>
                                                            </span>
                                                        :
                                                            null
                                                        }
    
                                                        {/* eyeclean */}
                                                        { value.eyeClean && value.eyeClean.toLowerCase() === "yes" ?
                                                            <span>
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip">
                                                                            100% Eye Clean
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="label label-light-info label-pill label-inline label-sm  mr-1 font-weight-bold px-2">100% EC</span>
                                                                </OverlayTrigger>
                                                            </span>
                                                        :
                                                            null
                                                        }
                                                        { value.eyeClean && value.eyeClean.toLowerCase() === "no" ?
                                                            <span>
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip">
                                                                            No Eye Clean
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="label label-light-danger label-pill label-inline label-sm  mr-1 font-weight-bold px-2">EC: NO</span>
                                                                </OverlayTrigger>
                                                            </span>
                                                        :
                                                            null
                                                        }
    
                                                        {/* growthtype */}
                                                        { value.diamondType === "L" && (value.growthType && value.growthType === "CVD") ?
                                                            <span>
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip">
                                                                            CVD
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="label label-light-success label-pill label-inline label-sm  mr-1 font-weight-bold px-2">CVD</span>
                                                                </OverlayTrigger>
                                                            </span>
                                                        :
                                                            null
                                                        }
                                                        { value.diamondType === "L" && (value.growthType && value.growthType === "HPHT") ?
                                                            <span>
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip">
                                                                            HPHT
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="label label-light-success label-pill label-inline label-sm  mr-1 font-weight-bold px-2">HPHT</span>
                                                                </OverlayTrigger>
                                                            </span>
                                                        :
                                                            null
                                                        }
                                                        
                                                        { (value.diamondType === "L" ) && (value.treatment && value.treatment.toLowerCase() === "as grown") ? 
                                                            <span>
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip">
                                                                            As Grown
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="label label-light-success label-pill label-inline label-sm  font-weight-bold px-2">As-G</span>
                                                                </OverlayTrigger>
                                                            </span>
                                                        : 
                                                            null
                                                        }
                                                        {/* natural treated */}
                                                        { (value.diamondType === "N" || value.diamondType === "W") && (value.treatment && value.treatment.toLowerCase() !== "none")  ? 
                                                            <span>
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip">
                                                                            Treated
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="label label-light-danger label-pill label-inline label-sm  font-weight-bold px-2">Tx</span>
                                                                </OverlayTrigger>
                                                            </span>
                                                        : 
                                                            null
                                                        }
                                                    </div>
                                                </td>
                                                <td className={`text-right  font-weight-bold  ${!available ? "CanNotHoldDiv" : "" }`} nowrap>
                                                    ${numberWithCommas(value.ourPrice)}
                                                    {value.supplierName?<OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip id="tooltip">
                                                               Supplier Price: ${value["supplierPrice"]}<br/>
                                                               Our Charges: ${(Math.round(value["newcharge"] * 100)/100).toFixed(2)} 
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span className="ml-2 text-hover-primary cursor-pointer"><FaInfoCircle /></span>
                                                    </OverlayTrigger>:""}<br/>
                                                    <span className="text-muted small">USD/CT {numberWithCommas(value.ourRate)}</span>
                                                </td>
                                                {value.ourPriceCustomer ?
                                                    <td align="center" className="text-right font-weight-bold py-3">
                                                        {value.ourPriceCustomerSymbol}{numberWithCommas(value.ourPriceCustomer)} <br />
                                                        <span className="small text-muted">{value.ourPriceCustomerSymbol}/CT {numberWithCommas(value.ourRateCustomer)}</span>
                                                    </td> 
                                                : null}
                                                <td className={`text-right align-middle  ${!available ? "CanNotHoldDiv" : "" }`}>
                                                    {value.addref  ? 
                                                        <input type="text" className="form-control" onChange={(e) => handleInputChange(e,data,index)} maxLength={30} placeholder="Please enter reference"/>
                                                    :
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id="tooltip">
                                                                Click to add Reference
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <button className="btn btn-icon btn-outline-primary btn-sm" onClick={()=> AddReference(data,index)}><FaEdit className="font-size-h5"/></button>
                                                        </OverlayTrigger>
                                                    }
                                                </td>
                                                {/* <td className={`text-right  `}>
                                                    ₹{numberWithCommas(value.ourPrice)} <br />
                                                    <span className="text-muted small">₹/CT {numberWithCommas(value.ourRate)}</span>
                                                </td> */}
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>
                            <div className=" font-weight-bold mt-4 font-italic" >{props.diamondselected.length > 4 ? "Scroll for explore all diamonds":""}</div>
                            {errorMessage && <p className="mb-1 text-danger">{errorMessage}</p>}
                            <div className="row my-5">
                            <div className="col-md-6">
                             {displayCoupon?<div className="row">   
                            <div class="col-md-8 input-group">
                            <input
                                type="text"
                                className="form-control"
                                onChange={(e) => setCouponCode(e.target.value)}
                                maxLength={30}
                                placeholder="Enter coupon code"
                                value={couponCode}
                                />
                                <div class="input-group-append">
                                <button class="btn btn-primary" type="button" onClick={handleApplyCoupon}>Apply</button>
                            </div>
                            </div>
                            
                            <div className="col-12">
                                {couponsuccessmsg?<span className="text-success small">{couponsuccessmsg}</span>:""}
                            {couponerrormsg?<span className="text-danger small">{couponerrormsg}</span>:""}
                            </div>
                            </div>:""}
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                {displayTotalUSD && customerCurrencySymbolName?<>
                                <div className="col-12 font-size-h6 text-right">
                                    USD/CT Price : ${numberWithCommas(totalourcarat)}
                                </div>
                                <div className="col-12 font-size-h6 mt-2 text-right font-weight-bold">
                                    Total USD : ${numberWithCommas(totalourprice)}
                                </div>
                                <div className="col-12 font-size-h6 mt-2 text-right font-weight-bold">
                                    Total {customerCurrencySymbolName} : {customerCurrencySymbol}{numberWithCommas(totalourpricecustomer)}
                                </div>
                                </>:customerCurrencySymbolName?<>
                                    <div className="col-12 font-size-h6 mt-2 text-right font-weight-bold">
                                    {customerCurrencySymbolName}/CT Price: {customerCurrencySymbol}{numberWithCommas(totalourratecustomer)}
                                </div>
                                <div className="col-12 font-size-h6 mt-2 text-right font-weight-bold">
                                    Total {customerCurrencySymbolName} : {customerCurrencySymbol}{numberWithCommas(totalourpricecustomer)}
                                </div>
                                </>:<>
                                <div className="col-12 font-size-h6 text-right">
                                    USD/CT Price : ${numberWithCommas(totalourcarat)}
                                </div>
                                <div className="col-12 font-size-h6 mt-2 text-right font-weight-bold">
                                    Total USD : ${numberWithCommas(totalourprice)}
                                </div>
                                </>}
                            </div>
                            </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    
                                    <Form.Group controlId="Notes">
                                        <Form.Label>
                                            {props.language.CONFIRM_GOODS_POPUP_NOTES}:
                                        </Form.Label>
                                        <Form.Control as="textarea" rows="3" onChange={(e) => SetComment(e.target.value)} maxLength={256} placeholder="Please enter your notes if any"/>
                                    </Form.Group>
                                    <span className="p-2">255 Characters Remaining</span>
                                </div>
                            </div>
                            {/* <pre>{JSON.stringify(props)}</pre> */}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-between py-3">
                    {props.conversionrate !== 1?<span className="font-weight-bold"> All Purchases are under USD</span>:""}
                    <div>
                        <Button variant="secondary" className="mr-2 font-weight-bold" onClick={() => closeModel(props)}>
                            {props.language.CONFIRM_GOODS_POPUP_CLOSE}
                        </Button>
                        {totalvalid?<Button disabled={isSubmitting} className="px-8 font-weight-bold" variant="primary" onClick={() => ConfirmDiamonds(data)}>
                        {props.language.CONFIRM_GOODS_POPUP_CONFIRM_ORDER}
                            {loading && <span className="ml-1 spinner spinner-white"></span>}
                        </Button>:""}
                    </div>
                </Modal.Footer>
            </Modal>
            <SwalSuccess show={swalSuccessOpen} message={alertMessage} onClose={() => setSwalSuccessOpen(false)} responseOnOk={reDirectToConfirm}/> 
            {/* <SwalError show={swalErrorOpen} message={alertMessage} onClose={() => setSwalErrorOpen(false)} closeBtn={true}/> */}
            { props.userinfo.kyc_status === "KYC_REJ" || props.userinfo.kyc_status === "NO_KYC"? (
            <>
                {swalErrorOpen && (
                    <SweetAlert
                        error
                        // title="Warning"
                        onConfirm={()=>history.push('/profile')}
                        confirmBtnText={props.userinfo.kyc_status === "NO_KYC" ? "Complete Profile" : "Revise Profile"}
                        confirmBtnBsStyle="primary"
                        showCancel
                        onCancel={() => setSwalErrorOpen(false)}
                        cancelBtnText="close"
                        cancelBtnBsStyle="secondary"
                    >
                       <span className="d-block mb-2 font-weight-bold">{alertMessage}</span>
                    </SweetAlert>
                )} 
            </>):(
                <>
                    {swalErrorOpen && (
                        <SweetAlert
                            error
                            // title="Warning"
                            onConfirm={() => setSwalErrorOpen(false)}
                            confirmBtnText="close"
                            confirmBtnBsStyle="primary"
                        >
                           <span className="d-block mb-2 font-weight-bold">{alertMessage}</span>
                        </SweetAlert>
                    )} 
                </>
            )}
        </div>
    );
};
